import DOMPurify from 'isomorphic-dompurify';
export var sanitize = function sanitize(dirty) {
  return DOMPurify.sanitize(dirty);
};